<mat-expansion-panel
  id="expansion-panel"
  class="expansion-panel"
  [ngClass]="panelStyleClasses"
  (opened)="setPanelOpenState(true)"
  (closed)="setPanelOpenState(false)"
  hideToggle="true"
>
  <mat-expansion-panel-header
    id="expansion-panel-header-wrapper"
    [ngClass]="headerStyleClasses"
    [collapsedHeight]="getPanelHeaderStyle()"
    [expandedHeight]="getPanelHeaderStyle()"
  >
    <mat-panel-title id="expansion-panel-title-wrapper">
      <div id="expansion-panel-header" class="expansion-panel-header-content">
        <ng-content
          id="expansion-panel-header-content"
          select=".expansion-panel-header"
        ></ng-content>
      </div>
    </mat-panel-title>
    <mat-panel-description
      id="expansion-panel-description-wrapper"
      [ngClass]="headerDescriptionClasses"
      [ngStyle]="headerDescriptionStyle"
      *ngIf="panelToggleIcon"
    >
      <app-icon
        id="expansion-panel-close-icon"
        *ngIf="panelOpenState"
        [name]="getPanelCloseStateIcon()"
        size="2em"
      ></app-icon>
      <app-icon
        id="expansion-panel-open-icon"
        *ngIf="!panelOpenState"
        [name]="getPanelOpenStateIcon()"
        size="2em"
      ></app-icon>
    </mat-panel-description>
  </mat-expansion-panel-header>
  <div id="expansion-panel-body" class="expansion-panel-body-content">
    <ng-content
      id="expansion-panel-body-content"
      select=".expansion-panel-body"
    ></ng-content>
  </div>
</mat-expansion-panel>
